<template>
  <div class="afspraak-page-container">
    <div class="page-header">
      <div class="container">
        <h1>Afspraak maken</h1>
        <p class="header-subtitle">
          Maak eenvoudig een afspraak bij Tandzorg Gestel
        </p>
      </div>
    </div>
    
    <div class="forms-container">
      <RegisterAppointment />
    </div>
  </div>
</template>

<script>
import RegisterAppointment from '../components/RegisterAppointment.vue'

export default {
  name: "AfspraakMaken",
  components: { 
    RegisterAppointment
  },
  mounted() {
    document.title = "Afspraak maken | Tandzorg Gestel | Online Afspraak Inplannen"
    document.querySelector('meta[name="description"]').setAttribute("content", "Maak eenvoudig online een afspraak bij Tandzorg Gestel. Snel en gemakkelijk inplannen voor tandheelkundige zorg.");
    this.$store.commit('updateActivePage', 'AfspraakMaken')
  }
}
</script>

<style scoped>
.afspraak-page-container {
  margin-top: 88px;
  min-height: calc(100vh - 88px);
}

.page-header {
  background: linear-gradient(135deg, #00b8b8 0%, #0891b2 100%);
  color: white;
  padding: 4rem 2rem;
  text-align: center;
}

.page-header h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.header-subtitle {
  font-size: 1.8rem;
  max-width: 600px;
  margin: 0 auto;
  opacity: 0.9;
  line-height: 1.5;
}

.forms-container {
  padding: 2rem 0;
}

@media (max-width: 768px) {
  .afspraak-page-container {
    margin-top: 55px;
  }
  
  .page-header {
    padding: 3rem 1rem;
  }
  
  .page-header h1 {
    font-size: 2.5rem;
  }
  
  .header-subtitle {
    font-size: 1.5rem;
  }
}
</style>
